import _implicitStylesheets from "./propertiesModal.css";

import _implicitScopedStylesheets from "./propertiesModal.scoped.css?scoped=true";

import {registerTemplate} from "lwc";
function tmpl($api, $cmp, $slotset, $ctx) {
  const {gid: api_scoped_id, d: api_dynamic_text, t: api_text, h: api_element, k: api_key, i: api_iterator, b: api_bind} = $api;
  const {_m0} = $ctx;
  return [$cmp.isModalOpen ? api_element("div", {
    key: 0
  }, [api_element("section", {
    classMap: {
      "slds-modal": true,
      "slds-fade-in-open": true
    },
    attrs: {
      "role": "dialog",
      "tabindex": "-1",
      "aria-labelledby": api_scoped_id("modal-heading-01"),
      "aria-modal": "true",
      "aria-describedby": api_scoped_id("modal-content-id-1")
    },
    key: 1
  }, [api_element("div", {
    classMap: {
      "slds-modal__container": true,
      "modal_pos-align": true
    },
    key: 2
  }, [api_element("header", {
    classMap: {
      "slds-modal__header": true
    },
    key: 3
  }, [api_element("h2", {
    classMap: {
      "slds-modal__title": true,
      "slds-hyphenate": true,
      "modal-title_align": true
    },
    attrs: {
      "id": api_scoped_id("modal-heading-01"),
      "data-my-id": "modalTitle"
    },
    key: 4
  }, [api_text(api_dynamic_text($cmp.modalTitle))])]), api_element("div", {
    classMap: {
      "slds-modal__content": true,
      "slds-p-around_medium": true,
      "modal-details_align": true
    },
    attrs: {
      "id": api_scoped_id("modal-content-id-1")
    },
    key: 5
  }, api_iterator($cmp.orgUserDetails, function (orgUser) {
    return [api_element("h3", {
      classMap: {
        "title-pos_align": true
      },
      attrs: {
        "data-my-id": "orgUserLabel"
      },
      key: api_key(6, orgUser.value)
    }, [api_element("span", {
      attrs: {
        "data-my-id": "orgUserTitle"
      },
      key: 7
    }, [api_text(api_dynamic_text(orgUser.label))])]), api_element("h3", {
      classMap: {
        "info-pos_align": true
      },
      attrs: {
        "data-my-id": "orgUserValue"
      },
      key: api_key(8, orgUser.value)
    }, [api_element("span", {
      attrs: {
        "data-my-id": "orgUserTitle"
      },
      key: 9
    }, [api_text(api_dynamic_text(orgUser.value))])])];
  })), api_element("footer", {
    classMap: {
      "slds-modal__footer": true
    },
    key: 10
  }, [api_element("button", {
    classMap: {
      "slds-button": true,
      "slds-button_brand": true,
      "modal-button_pos": true
    },
    key: 11,
    on: {
      "click": _m0 || ($ctx._m0 = api_bind($cmp.closeModal))
    }
  }, [api_text("OK")])])])])]) : null];
}
export default registerTemplate(tmpl);
tmpl.stylesheets = [];


if (_implicitStylesheets) {
  tmpl.stylesheets.push.apply(tmpl.stylesheets, _implicitStylesheets)
}
if (_implicitScopedStylesheets) {
  tmpl.stylesheets.push.apply(tmpl.stylesheets, _implicitScopedStylesheets)
}
tmpl.stylesheetToken = "my-propertiesModal_propertiesModal"
